export default __webpack_public_path__ + "static/image 2-1ef6f47b9333214d686e89e157c6e638.png";